/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type LazyProformaIssueFormsGeneralType from '@jira/spa-apps__proforma-issue-forms-general/src/ProformaJiraIssueFormsGeneralWrapper.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProformaIssueFormsGeneral: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof LazyProformaIssueFormsGeneralType
>(
	() =>
		import(
			/* webpackChunkName: "async-proforma-issue-forms-general", jiraSpaEntry: "async-proforma-issue-forms-general" */ '@jira/spa-apps__proforma-issue-forms-general/src/ProformaIssueForms.tsx'
		),
);

const AsyncProformaIssueFormsGeneral = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProformaIssueFormsGeneral}
		pageId="proforma-issue-forms-general"
		shouldShowSpinner
	/>
);

export default AsyncProformaIssueFormsGeneral;
